/**
 * NOTE: ALL the functions in this.dialogProps need to be processed, here has an example:
 *
 * If the dialogProps that we send in the PARENT COMPONENT look like:
 *
 * dialogProps: {
 *   ...
 *   myFunc: () => this.foo(),
 *   'show-close': false,
 *   ...
 * }
 *
 *
 * Then we'll need to handle the "myFunc" in the dialogProps since it's a FUNCTION,
 * we can set a new argument in the data() block
 *
 * data () {
 *   return {
 *     bar: () => this.dialogProps.myFunc(),
 *     ...
 *   }
 * }
 *
 *
 * And then don't forget to set the args.props in the render(h) block
 *
 * props: {
 *  myFuncProp: this.bar,
 *  ...
 * }
 *
 * Now you can go to check if the function(s) work(s) correctly!
 *
 */

export default {
  props: {
    dialogProps: Object,
    showModal: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showModal () {
      this.show = this.showModal
    }
  },
  data () {
    return {
      beforeClose: () => this.dialogProps.beforeClose(),
      show: this.showModal
    }
  },
  render (h) {
    const args = {
      on: {
        'update:visible': (val) => { this.show = val }
      },
      props: {
        ...this.dialogProps,
        beforeClose: this.beforeClose,
        visible: this.show
      }
    }
    return (
      <el-dialog {...args}>
        <span slot="title">
          { this.$slots.header }
        </span>
        { this.$slots.default }
        <span slot="footer">
          <div class="footer-content">
            { this.$slots['footer-content'] }
          </div>
          { this.$slots.actions }
        </span>
      </el-dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.js